import { isSubjectAllowedForActivityType } from "./assignmentSubjects.js";

export function initGroupForms(root = document) {
  const forms = [
    ...(root instanceof Element && root.matches("[data-group-form]") ? [root] : []),
    ...Array.from(root.querySelectorAll?.("[data-group-form]") ?? []),
  ];

  forms.forEach((form) => {
    if (form.dataset.groupFormInitialized === "1" || form.classList.contains("form--readonly")) return;

    const subject = form.querySelector('select[name="subject_id"]');
    const teacher = form.querySelector('select[name="teacher_id"]');
    const optionsElement = form.ownerDocument.getElementById(form.dataset.groupTeachersElementId);
    if (!subject || !teacher || !optionsElement) return;

    const teachersBySubject = JSON.parse(optionsElement.textContent);
    form.dataset.groupFormInitialized = "1";

    const updateTeachers = (preserveSelection = false) => {
      const teachers = teachersBySubject[subject.value] ?? [];
      const selected = preserveSelection && teachers.some((item) => item.id === teacher.value)
        ? teacher.value : "";
      const placeholder = !subject.value ? "Najpierw wybierz przedmiot"
        : teachers.length ? "Wybierz nauczyciela" : "Brak aktywnych nauczycieli dla tego przedmiotu";
      const options = [
        { value: "", text: placeholder },
        ...teachers.map((item) => ({ value: item.id, text: item.text })),
      ];

      if (teacher.tomselect) {
        teacher.tomselect.clear(true);
        teacher.tomselect.clearOptions();
        teacher.tomselect.addOptions(options);
        teacher.tomselect.settings.placeholder = placeholder;
        teacher.tomselect.inputState();
        teacher.tomselect.setValue(selected, true);
        teacher.tomselect.refreshOptions(false);
        if (subject.value) teacher.tomselect.enable();
        else teacher.tomselect.disable();
      } else {
        teacher.replaceChildren(...options.map((item) => new Option(item.text, item.value)));
        teacher.value = selected;
        teacher.disabled = !subject.value;
      }
    };

    subject.addEventListener("change", () => updateTeachers());
    updateTeachers(true);

    const subjectTypes = JSON.parse(form.dataset.groupSubjectTypes || "{}");
    for (const suffix of ["", "_2"]) {
      const subjectField = form.querySelector(`select[name="subject_id${suffix}"]`);
      const activityField = form.querySelector(`select[name="activity_type_id${suffix}"]`);
      if (!subjectField || !activityField?.dataset?.subjectRules) continue;

      const rules = JSON.parse(activityField.dataset.subjectRules);
      const allOptions = Array.from(subjectField.options, (option) => ({
        value: option.value, text: option.textContent, optionClass: option.getAttribute("data-option-class") || "",
        type_id: subjectTypes[option.value] ?? 0,
      }));
      const allowed = (value) => value === "" || isSubjectAllowedForActivityType(subjectTypes[value], activityField.value, rules);
      const validate = () => {
        subjectField.setCustomValidity(allowed(subjectField.value) ? "" : "Zmień przedmiot lub charakter zajęć. Ten przedmiot nie jest dozwolony dla wybranego charakteru zajęć.");
      };
      const updateSubjects = (preserveInvalid = false) => {
        const previous = subjectField.value;
        const selected = allowed(previous) || preserveInvalid ? previous : "";
        const options = allOptions.filter((option) => allowed(option.value) || option.value === selected);
        const select = subjectField.tomselect;
        if (select) {
          select.clear(true);
          select.clearOptions();
          select.addOptions(options.map((option) => ({ ...option, disabled: !allowed(option.value) })));
          select.setValue(selected, true);
          select.refreshOptions(false);
        } else {
          subjectField.replaceChildren(...options.map((item) => {
            const option = new Option(item.text, item.value);
            option.disabled = !allowed(item.value);
            option.setAttribute("data-option-class", item.optionClass);
            return option;
          }));
          subjectField.value = selected;
        }
        validate();
        if (previous !== selected) subjectField.dispatchEvent(new Event("change", { bubbles: true }));
      };
      subjectField.addEventListener("change", validate);
      activityField.addEventListener("change", () => updateSubjects());
      updateSubjects(true);
    }
  });
}
